export function addMinutes(time: string, minutes: number): string {
  const [h, m] = time.split(':').map(Number);
  const base = new Date(2000, 0, 1, h, m || 0, 0, 0);
  const end = new Date(base.getTime() + minutes * 60000);
  const hh = String(end.getHours()).padStart(2, '0');
  const mm = String(end.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

export function toMinutes(time?: string): number {
  if (!time) return -1;
  const [h, m] = time.split(':').map(Number);
  return (isNaN(h) ? 0 : h) * 60 + (isNaN(m) ? 0 : m);
}

export function formatDateYmd(d: Date): string {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
